import { useState } from 'react';

export const useDitUploadSource = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadDitSource = async ({ file, presignedUrl }) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(presignedUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': '',
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      return response;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    uploadDitSource,
    loading,
    error,
  };
};
